import { useState, useEffect } from 'react'

const useClassifications = (props) => {
    const cacheMinutes = 60
    const localStorageKey = 'classifications'
    const localStorageData = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)) : {}
    const [lastUpdated, _setLastUpdated] = useState(localStorageData?.lastUpdated || 0)
    const [classifications, _setClassifications] = useState(localStorageData?.classifications || [])
    
    useEffect(() => {
        if( classifications.length === 0 ) {
            reloadClassifications()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reloadClassifications()
    }, [])

    const reloadClassifications = () => {
        fetch('/v0/classifications', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                const results = json.results
                _setLastUpdated(Date.now())
                _setClassifications(results)
                localStorage.setItem(localStorageKey, JSON.stringify({
                    lastUpdated: Date.now(),
                    classifications: results,
                }))
            })
    }

    return {
        classifications,
        reloadClassifications,
    }
}

export default useClassifications
